export default __webpack_public_path__ + "static/media/wallpaper_04.987fc2cb.jpg";